import { deleteCoreSetupAuditTrailViewsSlice } from './delete';
import { getCoreSetupAuditTrailViewsSlice } from './get';
import { patchCoreSetupAuditTrailViewsSlice } from './patch';
import { postCoreSetupAuditTrailViewsSlice } from './post';

export const { requestDeleteCoreSetupAuditTrailViews, resetDeleteCoreSetupAuditTrailViews } =
	deleteCoreSetupAuditTrailViewsSlice.asyncActionCreators;

export const { requestGetCoreSetupAuditTrailViews, resetGetCoreSetupAuditTrailViews } =
	getCoreSetupAuditTrailViewsSlice.asyncActionCreators;

export const { requestPatchCoreSetupAuditTrailViews, resetPatchCoreSetupAuditTrailViews } =
	patchCoreSetupAuditTrailViewsSlice.asyncActionCreators;

export const { requestPostCoreSetupAuditTrailViews, resetPostCoreSetupAuditTrailViews } =
	postCoreSetupAuditTrailViewsSlice.asyncActionCreators;
